import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import SlideSearchTaggingModal from './UploadProgressModal/Tagging/SlideSearchTaggingModal';
import SlideSearchUploadingModal from './UploadProgressModal/Uploading/SlideSearchUploadingModal';
/**
 * アップロード進捗状況を表示するためのモーダル
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchUploadModal = (props) => {
    const { hideModal, isShow, modalInformation } = props;
    const currentProgress = modalInformation.progress || 0;
    const isUploadComplete = currentProgress >= 100;
    return (_jsxs(_Fragment, { children: [_jsx(SlideSearchUploadingModal, { hideModal: hideModal, isShow: !!(isShow && !isUploadComplete), progress: currentProgress }), _jsx(SlideSearchTaggingModal, { hideModal: hideModal, isShow: !!(isShow && isUploadComplete), modalInformation: modalInformation })] }));
};
SlideSearchUploadModal.propTypes = {
    hideModal: propFunc().isRequired,
    isShow: propBool().isRequired,
    modalInformation: propShape().isRequired,
};
export default SlideSearchUploadModal;
